module.exports = __webpack_public_path__ + "img/强雷阵雨.b8a8d86b.png";